import React, { useContext, useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from "@apollo/client";

import { Link, useNavigate } from "react-router-dom";

import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from '../../../../../context/UserContext';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';


import HtlWarehSubEdit from "./HtlWarehSubEdit";
//import HtlAgnOffChart from "./HtlAgnOffChart";
//import HtlPeriods from "./HtlPeriods";

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import { InputSwitch } from "primereact/inputswitch";
import { Divider } from 'primereact/divider';
import { Tooltip } from 'primereact/tooltip';
import CustommerProfileCorp from "./CustommerProfileCorp";





const GET_POST = gql`
query MyQuery(
    $resMidId: Int
    $resRoomId: Int
    $resGuestId: Int
  
  

    ) {
        tbl_rez_guest_mid_list(where: {
            rez_mid_id: {_eq: $resMidId}
            rez_room_id: {_eq: $resRoomId}
            guest_id: {_eq: $resGuestId}
         
    }) {
       
       rez_top_id
       rez_mid_id
       rez_room_id
       guest_id
       profile_id
       title
       name
       last_name
       age
       country
       guest_type
   
    

  } 
  
}
`;

const GET_PROFILE = gql`
query MyQuery(
   
   
    $profileId: Int
   

    ) {
      tbl_customer_profile_corp
      (where: {
        cust_profile_id: { _eq: $profileId },
       
      
   
       
      
    }) {
       
      cust_profile_id
      title
      first_name
      middle_name
      last_name
      birth_date
      nationality
      member_class
      member_club
      hidden
     


   
    

  }
  
}
`;

const GET_AVA_CONT= gql`
query MyQuery(
    $resMidId: Int
    $resRoomId: Int
    $ownFirmCode: String
    $ownFirmSubCode: String
    $resRoomType: String
    $startDate: date
    $endDate: date

    ) {
      tbl_htl_room_type_ava_dtl_sts
      (where: {
        room_type: { _eq: $resRoomType },
        firm_main_code: { _eq: $ownFirmCode },
        firm_sub_code: { _eq: $ownFirmSubCode },        
        _and: [
          { date: { _gte: $startDate } },
          { date: { _lte: $endDate } }
        ] 
   
       
      
    }) {
       
      
       room_class
       room_type
       date
       room_total_contg
       room_contg_use
       room_total_gua
       room_gua_use
       quata_use
       change_contg
       pseudo
       
   
    

  }
  
}
`;

const GET_GUEST_LIST = gql`
query MyQuery(
    $resMidId: Int
    $resRoomId: Int
  
  

    ) {
      tbl_rez_guest_mid_list(where: {
            rez_mid_id: {_eq: $resMidId}
            rez_room_id: {_eq: $resRoomId}
          
       
    }) {
       
       rez_top_id
       rez_mid_id
       rez_room_id
       guest_id
       profile_id
       title
       name
       last_name
       age
       country
       guest_type
       hidden
       member_class
       member_club

       
    

  } 
  
}
`;

const UPDATE_GUEST = gql`
mutation UpdateRoom(
    $resMidId: Int
    $resRoomId: Int
    $resGuestId: Int
    $profileId:  Int
    $guestTitle: String
    $guestName: String
    $guestLastN: String
    $guestAge: Int
    $guestCountry: String
    $guestGuestType: String

   
    
  ) {
    update_tbl_rez_guest_mid_list(
      where: {
        rez_mid_id: {_eq: $resMidId}
        rez_room_id: {_eq: $resRoomId} 
        guest_id: {_eq: $resGuestId}         
       
      }
      _set: {
        
        profile_id: $profileId
        title: $guestTitle
        name: $guestName
        last_name: $guestLastN
        age: $guestAge
        country: $guestCountry
        guest_type: $guestGuestType

       
      }
    ) {
      affected_rows
    }
  }
`; 




const INSERT_GUEST = gql`
  mutation InsertRoom(
    $resTopId: Int
    $resMidId: Int
    $resRoomId: Int
    $resGuestId: Int
    $profileId:  Int
    $guestTitle: String
    $guestName: String
    $guestLastN: String
    $guestAge: Int
    $guestCountry: String
    $guestGuestType: String
   

   
    
  ) {
    insert_tbl_rez_guest_mid_list(
      objects: {


        profile_id: $profileId,
        title: $guestTitle,
        name: $guestName,
        last_name: $guestLastN,
        age: $guestAge,
        country: $guestCountry,
        guest_type: $guestGuestType,
      
        rez_top_id: $resTopId,
        rez_mid_id: $resMidId,
        rez_room_id: $resRoomId,
        guest_id: $resGuestId,  
       
      

        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_ROOM_TYPE = gql`
query GetHtlRoomsTyp(
    $ownFirmCode: String
    $ownFirmSubCode: String
    $resMidId: Int
   
  ) {
    tbl_rez_rooms(
      order_by: { rez_mid_id: asc },
      where: {
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
        rez_mid_id: { _eq: $resMidId }
 
      }
    ) {
      firm_main_code
      firm_sub_code
      rez_mid_id
      rez_room_id
      room_class
      room_type
      arrival_date
      departure_date
      firm_main_code
      firm_sub_code
      
    }
  }
`;

const GET_ROOM_CLASS = gql`
query GetHtlRoomsCls(
    $ownFirmCode: String
    $ownFirmSubCode: String
   
  ) {
    tbl_htl_room_class(
      order_by: { r_class_code: asc },
      where: {
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      
      }
    ) {
      firm_main_code
      firm_sub_code
      r_class_code
      r_class_name
      active
    }
  }
`;


const GET_GUEST_TITLE = gql`
  query MyQuery( $lang: String, $defType: String,) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const GET_GUEST_MEMBER = gql`
  query MyQuery( $lang: String, $defType: String,) {
    tbl_gnl_def(
      where: {        
        lang: { _eq: $lang },
        type: { _eq: $defType },
        
       
      }
    ) {
      lang
      type
      code
      name
      opt_1
    }
  }
`;

const UPDATE_RULES = gql`
mutation UpdateRules(
    $dprMainCode: String
    $ownFirmCode: String
    $ownFirmSubCode: String
    $rulesName: String   
    $ruleType: String
    $active: Boolean
   
    
  ) {
    update_tbl_dpr_main(
      where: {
        dpr_main_code: { _eq: $dprMainCode }
        firm_main_code: { _eq: $ownFirmCode }
        firm_sub_code: { _eq: $ownFirmSubCode }
      }
      _set: {
        
        dpr_dpr_type: $ruleType
        dpr_main_name: $rulesName
        active: $active
       
      }
    ) {
      affected_rows
    }
  }
`; 

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const GET_CONTRACT_PRICES = gql`
  query GetContractPrices($ownFirmCode: String, $contId: Int, $resRoomType: String, $perAdl: Int) {
    tbl_cont_per_def(where: {
      firm_main_code: { _eq: $ownFirmCode }
      cont_id: { _eq: $contId }
    }) {
      start_date
      end_date
      period
      cont_id      
        get_per_price_chl(where: { 
         
          child: { _gte: 1, _lte: 2 }
          r_type_code: { _eq: $resRoomType } 
        }) {
        cont_id        
        period        
        per_price
        currency
        adult
     
      }
      get_per_price(where: { 
        adult: { _eq: $perAdl }
        r_type_code: { _eq: $resRoomType }
      }) {
        cont_id        
        period        
        per_price
        currency
        adult
      }
    }
  }
`;

const GET_FIRM_SUB_COOP_K2 = gql`
  query GetFilteredFirms(
    $ownFirmCode: String
   
   
    
  ) {
    tbl_customer_profile_corp(order_by: { firm_main_code: asc },
      where: {
        firm_main_code: { _eq: $ownFirmCode }
      
        
        
      }
    ) {
      cust_profile_id
      title
      first_name
      middle_name
      last_name
      birth_date
      nationality
      member_class
      member_club


    }
  }
`;







const HtlResRoomGuestEdit = () => {

   const {varCode, setVarCode} = useContext(ThemeContext);
   const {varCode4, setVarCode4} = useContext(ThemeContext);
   const {varCode7, setVarCode7} = useContext(ThemeContext);
   const {varCode8, setVarCode8} = useContext(ThemeContext);
   const {varCode9, setVarCode9} = useContext(ThemeContext);
   const {varCode10, setVarCode10} = useContext(ThemeContext);
   const {varCode14, setVarCode14} = useContext(ThemeContext);
  const {userName, setUserName} = useContext(ThemeContext);
  
  
  const { users } = useContext(UserContext);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  const ownFirmSubType = users.usertype;

  const ownFirmMainCode = users.firmcode;
 
  

  const lang = users.userLang;

  




 

  

     
   
  
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { resMidId: varCode4, resRoomId: varCode8, resGuestId: varCode14 },
  });





  const firmData = data && data.tbl_rez_guest_mid_list ? data.tbl_rez_guest_mid_list[0] : null;
  
 

  const [updateRulesPrn] = useMutation(UPDATE_GUEST);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 
  const [InsertSeason] = useMutation(INSERT_GUEST);

  const [displayBasic, setDisplayBasic] = useState(false);

  
  
  
 // const [firmCode, setFirmcode] = useState(firmData ? firmData.firm_main_code_n : "");
 const [firmCode, setFirmCode] = useState('');
 const [firmName, setFirmName] = useState("");
  const [firmType, setFirmType] = useState("AGN");
  const [place, setPlace] = useState("");
 // const [fmActive, setFmActive] = useState(firmData ? firmData.active : false); 
 // const [seaDesc, setSeaDesc] = useState(firmData ? firmData.firm_sub_code_k : ""); 
  const [rulPernId, setRulPernId] = useState(firmData ? firmData.rez_mid_id : ""); 
  const [firmTrg, setFirmTrg] = useState(""); 
  const [rulesName, setRulesName] = useState(firmData ? firmData.dpr_main_name : ""); 
 // const [ruleClass, setRulesClass] = useState(firmData ? firmData.build_plan_type : ""); 
  const [ruleType, setRulesType] = useState(firmData ? firmData.dpr_dpr_type : ""); 
  const [active, setActive] = useState(firmData ? firmData.active : ""); 
  const [ruleClass2, setRulesClas2] = useState(); 

  const [resMidId, setResMidId] = useState(firmData ? firmData.rez_mid_id : varCode4); 
  const [resRoomId, setResRoomId] = useState(firmData ? firmData.rez_room_id : varCode8); 
  const [resTopId, setResTopId] = useState(firmData ? firmData.rez_top_id : varCode7); 
  const [resFolioId, setResFolioId] = useState(firmData ? firmData.folio_id : ""); 
  const [resRoomClass, setResRoomClass] = useState(firmData ? firmData.room_class : ""); 
  const [resRoomType, setResRoomType] = useState(firmData ? firmData.room_type : ""); 
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.arrival_date): (new Date(varCode9)));
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.departure_date) : (new Date(varCode10)));
  const [perAdl, setPerAdl] = useState(firmData ? firmData.person_adl : 0); 
  const [perChl, setPerChl] = useState(firmData ? firmData.person_chl : 0); 


  const [resGuestId, setResGuestId] = useState(firmData ? firmData.guest_id : 0); 
  const [profileId, setProfileId] = useState(firmData ? firmData.profile_id : 0); 
  const [guestTitle, setGuestTitle] = useState(firmData ? firmData.title : ""); 
  const [guestName, setGuestName] = useState(firmData ? firmData.name : ""); 
  const [guestLastN, setGuestLastN] = useState(firmData ? firmData.last_name : ""); 
  const [guestAge, setGuestAge] = useState(firmData ? firmData.age : 0); 
  const [guestCountry, setGuestCountry] = useState(firmData ? firmData.country : ""); 
  const [guestGuestType, setGuestType] = useState(firmData ? firmData.guest_type : ""); 



  
 // const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
 // const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());

  const [openModal, setOpenModal] = useState(false);
  const [modalParam, setModalParam] = useState('');
  const [verim, setVerim] = useState('T0002');
  const {theme, setTheme} = useContext(ThemeContext);



  const [activeTab, setActiveTab] = useState(0);
  const [activeTabS, setActiveTabS] = useState(0);

  
  const [rows1, setRows1] = useState(20); // rows1'i tanımlayın ve başlangıç değeri ayarlayın
  const [first1, setFirst1] = useState(0);


  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleTabChangeS = (index) => {
    setActiveTabS(index);
  };

  const [visible2, setVisible2] = useState(false);



  
  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
 
  const new_rule_grp_btn = messages[currentLocale].new_rule_grp_btn;
  const new_rule_btn = messages[currentLocale].new_rule_btn;
  const rule_grp_id_title = messages[currentLocale].rule_grp_id_title;
  const rule_desc_title = messages[currentLocale].rule_desc_title;
  const rule_class_title = messages[currentLocale].rule_class_title;
  const currentPageReportTemplate = messages[currentLocale].currentPageReportTemplate;
  const statusrec = messages[currentLocale].statusrec;
  const activerec = messages[currentLocale].activerec;
  const inactiverec = messages[currentLocale].inactiverec;
  const update = messages[currentLocale].update;
  const rule_class_name_title = messages[currentLocale].rule_class_name_title;
  const rule_type_title = messages[currentLocale].rule_type_title;
  const rule_type_name_title = messages[currentLocale].rule_type_name_title;
  const select_rule_class_hint = messages[currentLocale].select_rule_class_hint;
  const select_rule_type_hint = messages[currentLocale].select_rule_type_hint;
  const rule_detail_title = messages[currentLocale].rule_detail_title;
  const rule_id_title = messages[currentLocale].rule_id_title;
  const detail = messages[currentLocale].detail;
  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;

  const search_by_firm_name = messages[currentLocale].search_by_firm_name;
  const firm_code = messages[currentLocale].firm_code;
  const firm_name = messages[currentLocale].firm_name;
  const firm_type = messages[currentLocale].firm_type;
 
  

  const { loading: fsck2loading, error: fsc2lerror, data: fsck2Data, refetch: profilerefech } = useQuery(GET_FIRM_SUB_COOP_K2, {
    variables: { ownFirmCode :ownFirmCode},
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm1, searchTerm2] = searchTerm.toLowerCase().split(' ');

  const filteredSubFirms = fsck2Data && fsck2Data.tbl_customer_profile_corp
  ? fsck2Data.tbl_customer_profile_corp.filter((firm) => {
      // İlk arama terimi (isim için)
      const searchFields = ['first_name', 'middle_name', 'last_name'];
      const matchesFirstSearch = searchFields.some(field => 
        firm[field] && firm[field].toLowerCase().includes(searchTerm1)
      );

      // İkinci arama terimi (soyadı için)
      const matchesSecondSearch = searchTerm2 ? 
        (firm.last_name && firm.last_name.toLowerCase().includes(searchTerm2)) : 
        true;

      // İki terim de eşleşiyorsa veya ikinci terim boşsa
      return matchesFirstSearch && matchesSecondSearch;
    })
  : [];



  

  const { loading: defLoading, error: defError, data: defData } = useQuery(GET_GUEST_TITLE, {
    variables: {defType: "PTIT", lang: currentLocale },
  });

  const { loading: defLoading3, error: defError3, data: defData3 } = useQuery(GET_GUEST_MEMBER, {
    variables: {defType: "MEMT", lang: currentLocale },
  });

  const { loading: defLoading2, error: defError2, data: defData2 } = useQuery(GET_ROOM_TYPE, {
    variables: {resMidId: resMidId,  ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode},
  });

  const localStartDate = new Date(startDate);
  const localEndDate = new Date(endDate);


    const { loading: loodingava, error: errorava, data: dataava, refetch: refechava } = useQuery(GET_PROFILE, {
    variables: { profileId: profileId, ownFirmCode: ownFirmCode,} 
      
    
  });

  //const firmData2 = dataava && dataava.tbl_htl_room_type_ava_sts ? dataava.tbl_htl_room_type_ava_sts[0] : null;
  const firmData2 = dataava && dataava.tbl_customer_profile_corp;

  const { loading: loodingavacont, error: erroravacont, data: dataavacont, refetch: refechavacont } = useQuery(GET_AVA_CONT, {
    variables: { resRoomType:resRoomType, ownFirmCode: ownFirmCode, ownFirmSubCode: ownFirmSubCode, 
      
      startDate: localStartDate.toLocaleDateString(),
      endDate: localEndDate.toLocaleDateString(), },
  });

  //const firmData2 = dataava && dataava.tbl_htl_room_type_ava_sts ? dataava.tbl_htl_room_type_ava_sts[0] : null;
  const firmData3 = dataavacont && dataavacont.tbl_htl_room_type_ava_dtl_sts;

  const { loading: loodinggue, error:errorgue, data: datague, refetch: refechgue } = useQuery(GET_GUEST_LIST, {
    variables: { resMidId: resMidId, resRoomId: resRoomId },
  });

  const firmData5 = datague && datague.tbl_rez_guest_mid_list;


  const dates = [];

  const { loading:pricelooding, error:errorprice, data:dataprice } = useQuery(GET_CONTRACT_PRICES, {
    variables: { ownFirmCode: ownFirmCode, contId: 30200, resRoomType: resRoomType, perAdl: perAdl },
  });

  const firmData4 = dataprice && dataprice.tbl_cont_per_def;

  if (firmData4) {
    firmData4.forEach(contract => {
      const startDate = new Date(contract.start_date);
      const endDate = new Date(contract.end_date);
      const datesInRange = [];
      
      for (let date = startDate; date <= endDate; date.setDate(date.getDate() + 1)) {
        datesInRange.push(new Date(date));
      }
      
      // Her bir kayıt için tarih aralığını yazdır
      console.log(`Contract ID: ${contract.cont_id}`);
      console.log("Dates in Range:");
      datesInRange.forEach(date => {
        console.log(date.toISOString().split('T')[0]);
      });
    });
  }

const arrivalDate = new Date(startDate);
const departureDate = new Date(endDate);


let totalPerPrice = 0;
let totalAdlPrice = 0;
let totalChlPrice = 0;

  const rows = [];
  if (firmData4) {
    firmData4.forEach(contract => {
      const startDate = new Date(contract.start_date);
      const endDate = new Date(contract.end_date);
  
      // İlgili sözleşmenin varış ve ayrılış tarihleri arasındaki her bir gün için bir satır oluştur
      for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
        // Tarih formatını ayarla (GG/AA/YYYY gibi)
        const formattedDate = date.toLocaleDateString('en-GB');
  
        // İlgili tarihler arasında olanlar için satır ekleyin
        if (date >= arrivalDate && date <= departureDate) {

          
          // Currency değerlerini al, eğer get_per_price tanımlıysa
          const currencies = contract.get_per_price ? contract.get_per_price.map(price => price.currency).join(', ') : "N/A";
        
          // Per_price değerlerini al, eğer get_per_price tanımlıysa
          const perPrices = contract.get_per_price ? contract.get_per_price.map(price => price.per_price).join(', ') : "N/A";
          const chlPrices = contract.get_per_price_chl ? contract.get_per_price_chl.map(price => price.per_price).join(', ') : "N/A";
          // Her bir tarih için bir satır oluştur ve rows dizisine ekle
          
          const totalPerPriceForDay = contract.get_per_price ? contract.get_per_price.reduce((total, price) => total + price.per_price, 0) : 0;
          const totalChlPriceForDay = contract.get_per_price_chl ? contract.get_per_price_chl.reduce((total, price) => total + price.per_price, 0) : 0;
        
          totalAdlPrice += totalPerPriceForDay;
          totalChlPrice += totalChlPriceForDay;
          rows.push({
            date: formattedDate,
            period: contract.period, // contract objesindeki periodu al
            currency: currencies, // Currency değerlerini ekleyin
            per_price: perPrices, // Per_price değerlerini ekleyin
            chl_price: chlPrices ,
            total_price: (totalPerPriceForDay + totalChlPriceForDay).toFixed(2) // Toplam fiyatı ekleyin
          });
  
          // Per_price değerlerini toplamPerPrice'a ekleyin
          if (contract.get_per_price) {
            contract.get_per_price.forEach(price => {
              totalPerPrice += price.per_price;
            });
          }
        }
      }
    });
  }

  //const totalPerPriceText = totalAdlPrice.toFixed(2) + totalChlPrice.toFixed(2);
  const totalPerPriceText = (totalAdlPrice + totalChlPrice).toFixed(2);

// Toplam fiyatı tabloda göstermek için rows dizisine bir satır ekleyin
rows.push({
  date: "Total", // Toplam için tarih alanı belirtilebilir
  period: "", // Toplam için period alanı boş bırakılabilir
  currency: "EUR", // Toplam için currency alanı boş bırakılabilir
  per_price: totalPerPriceText // Toplam fiyatı per_price alanına ekleyin
});





const handleRowAction = (rowData) => {
  setGuestName(rowData.first_name);
  setGuestLastN(rowData.last_name);
  setGuestTitle(rowData.title);
  setProfileId(rowData.cust_profile_id);
  setGuestCountry(rowData.nationality);
  setGuestType(rowData.member_class);
  setVisible2(false);
};



useEffect(() => {
  if (filteredSubFirms.length === 1) {
    const handleEnterPress = (event) => {
      if (event.key === 'Enter') {
        handleRowAction(filteredSubFirms[0]);
      }
    };

    window.addEventListener('keydown', handleEnterPress);

    return () => {
      window.removeEventListener('keydown', handleEnterPress);
    };
  }
}, [filteredSubFirms]);






  useEffect(() => {
    
    refetch();  
   
    console.log('Sayfa açıldı!');
    
    // componentWillUnmount
    return () => {
      console.log('Sayfa kapatılıyor...');
      refetch();  
     
    };
  }, []);

 





  useEffect(() => {
    
    if (firmTrg !== '') {
      // newId güncellendiğinde
    handleinser();  
    
    }
  }, [firmTrg, setFirmTrg]);


 

  useEffect(() => {
    if (firmData) {




        setResTopId(varCode7);
        setResMidId(varCode4);
        setResRoomId(firmData.rez_room_id);
        setResFolioId(firmData.folio_id);
        setResRoomClass(firmData.room_class);
        setResRoomType(firmData.room_type);
        setStartDate(new Date(firmData.arrival_date));
          setEndDate(new Date(firmData.departure_date));
          setPerAdl(firmData.person_adl);
          setPerChl(firmData.person_chl);

          setResGuestId(firmData.guest_id);
          setProfileId(firmData.profile_id);
          setGuestTitle(firmData.title);
          setGuestName(firmData.name);
          setGuestLastN(firmData.last_name);
          setGuestAge(firmData.age);
          setGuestCountry(firmData.country);
          setGuestType(firmData.guest_type);

 

     
      
    }
  }, [firmData]);

  


  

  const handleUpdate = () => {
   
    
    updateRulesPrn({
      variables: {
      

        resMidId: resMidId,
        resRoomId: resRoomId,
        profileId: profileId,
        resGuestId: resGuestId,
        guestTitle: guestTitle,
        guestName: guestName,
        guestLastN: guestLastN,
        guestAge: guestAge,
        guestCountry: guestCountry,
        guestGuestType: guestGuestType,
     

        
      },
    })
      .then(() => {
        window.alert(" updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating firm:", error);
      });
  }; 

  const handleUpdateIdSeq = async () => {
    const requiredFields = ['guestName', 'guestLastN' ]; // Required fiels
    const customFieldNames = {
        guestName: "Name",
     
        guestLastN: "Last name",

    

    };
    const emptyFields = getEmptyFields(requiredFields, customFieldNames); // Boş alanları kontrol et
  
    if (emptyFields.length === 0) {
      try {
        const { data } = await updateIdSeq2({
          variables: {
            type: 'MFIRM', 
          },
        });
        const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
        console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
        console.log(varCode7);
        
        setFirmTrg(String(updatedIdSeq));
      
        setResGuestId(updatedIdSeq);
        
       
        setResMidId(varCode4);
     //   setIdSeqTrg(updatedIdSeq);
        
        console.log(varCode7);
        // setVarCode(updatedIdSeq.toString());  
      } catch (error) {
        console.error('Güncelleme hatası:', error);
      }
    } else {
      
      const emptyFieldsMessage = `Boş Alanları Doldurun: ${emptyFields.join(', ')}`;
     // console.log(emptyFieldsMessage);
      window.alert(emptyFieldsMessage);
    }
  };

  const getEmptyFields = (requiredFields, customFieldNames) => {
    const emptyFields = [];
  
    // Boş olan alanları bul
    for (const field of requiredFields) {
      if (!eval(field)) {
        emptyFields.push(customFieldNames[field]);
      }
    }
  
    return emptyFields;
  };

  const handleinser = () => {
    InsertSeason({
      variables: {

        
        resTopId: varCode7,
        resMidId: varCode4,
        resRoomId: varCode8,
        resGuestId: resGuestId,

        profileId: profileId,
        guestTitle: guestTitle,
        guestName: guestName,
        guestLastN: guestLastN,
        guestAge: guestAge,
        guestCountry: guestCountry,
        guestGuestType: guestGuestType,




    
    
           
      },
    })
      .then(() => {
        window.alert("Rules insert successfully!");
      })
      .catch((error) => {
        console.error("Error insert Rules:", error);
      });
  };


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

      
  const onClick = () => {
   // setVarCode9(ruleType)
    
    setDisplayBasic(true);
    
  };

  const onClick3 = () => {
    // setVarCode9(ruleType)
     setVarCode(0);   
     profilerefech();
     setDisplayBasic(true);
     
   };

  const onClick2 = () => {
    setVarCode8('0');     
   // setVarCode9(ruleType)
    setDisplayBasic(true);
    
  };
  
  const onHide = () => {
    setDisplayBasic(false);
    profilerefech();
    refetch();
  };


  const getStatusLabel = (rowData) => {
    const statusClass = rowData.hidden
      ? "text-purple-800 font-bold text-sm"
      : "text-gray-500 font-bold text-sm";
  
    return (
      <div className={statusClass}>
      {rowData.hidden ? (
        <FormattedMessage id={activerec} />
      ) : (
        <FormattedMessage id={inactiverec} />
      )}
    </div>
    );
  };


  const guesttitletems = defData && defData.tbl_gnl_def
  ? defData.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name, 
    }))
  : [];

  const rulesTypeItems = defData2 && defData2.tbl_rez_rooms
  ? defData2.tbl_rez_rooms.map(item => ({
      label: item.room_type,
      value: item.rez_room_id,
      name: item.room_type, 
    }))
  : [];

  const guestMemberIems = defData3 && defData3.tbl_gnl_def
  ? defData3.tbl_gnl_def.map(item => ({
    label: item.name,
    value: item.code,
    name: item.name, 
    }))
  : [];

  const getTooltipId = (rowData) => `tooltip-${rowData.cust_profile_id}`;
  

 






  return (

    <div className="container -mt-4 mx-auto sm:p-4 ">
      
  
   


         <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTab} onTabChange={(e) => handleTabChange(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTab === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Room Guest Detail"}
            </span>
          }
          className="ml-5 flex"
        >
      <div>


      <Dialog
  header="Header2"
  visible={visible2}
  style={{ width: '50vw' }}
  onHide={() => setVisible2(false)}
>
  <div className="m-0 h-96">
    <div className="bg-purple-100 flex ml-5 mr-5">
      <div className="container bg-purple-50 p-2 mx-auto">
        <div className="w-full text-gray-950 flex items-center gap-4">
          <div className="relative w-full">
            <input
              type="text"
              className="w-30 px-4 py-2 pl-10 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Search Profile"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
            <svg
              className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 21l-4.35-4.35M17 10.5A6.5 6.5 0 104.5 4a6.5 6.5 0 0012.5 6.5z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div className="p-3 text-sm text-right border-b border-opacity-20 dark:border-gray-700 dark:bg-gray-900">
        <DataTable
          scrollable
          scrollHeight="350px"
          loading={loading}
          value={filteredSubFirms}
          paginator
          responsiveLayout="scroll"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate={currentPageReportTemplate}
          rows={rows1}
          first={first1}
          onPage={(e) => setFirst1(e.first)}
          onRowsPerPageChange={(e) => setRows1(e.value)}
          tableStyle={{ minWidth: '30rem', maxHeight: '30rem' }}
        >
          <Column
            className="font-bold text-sm"
            field="cust_profile_id"
            style={{ textAlign: 'center', width: '8rem' }}
            header={firm_code}
            body={(rowData) => (
              <span id={getTooltipId(rowData)}>
                {rowData.cust_profile_id}
                <Tooltip target={`#${getTooltipId(rowData)}`} content={`Profile ID: ${rowData.cust_profile_id}`} />
              </span>
            )}
          ></Column>
          <Column className="font-bold text-sm" field="title" style={{ textAlign: 'center', width: '8rem' }} header={firm_code}></Column>
          <Column className="text-sm" field="first_name" style={{ textAlign: 'center', width: '7rem' }} header={<span sortable className="font-bold text-gray-900">{firm_name}</span>}></Column>
          <Column className="text-sm" field="middle_name" style={{ textAlign: 'center', width: '20rem' }} header={<span className="font-bold text-gray-900">{firm_type}</span>}></Column>
          <Column className="text-sm" field="last_name" style={{ textAlign: 'center', width: '20rem' }} header={<span className="font-bold text-gray-900">{firm_type}</span>}></Column>
          <Column field="firm_sub_code_n" className="font-bold text-xs" style={{ textAlign: 'center', width: '7rem' }} header={<span className="font-bold text-gray-900">{"int_id"}</span>}></Column>
          <Column
            header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
            body={(rowData) => (
              <button
                onClick={() => handleRowAction(rowData)}
                className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
              >
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                  <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
                </svg>
              </button>
            )}
            style={{ textAlign: 'center', width: '6rem' }}
          ></Column>
        </DataTable>
      </div>
    </div>
  </div>
</Dialog>

    
    <div className=" p-2 ">
         <div className="pt-1"> 
           <Fieldset>
             <p className="my-0  ">

                


      <div className="flex gap-4">
    
          <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Mid Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={resMidId}
    onChange={(e) => setResMidId(e.target.value)}
    readOnly
    />
  </div>

  <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Room Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={resRoomId}
    onChange={(e) => setResRoomId(e.target.value)}
    readOnly
    />
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Room"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
       style={{ width: '95%' }}
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={resRoomId}
         options={rulesTypeItems}
         onChange={(e) => setResRoomId(e.value)}
         placeholder={"Room"}
         />
       </div>



  <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Guest Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={resGuestId}
    onChange={(e) => setResGuestId(e.target.value)}
    readOnly
    />
  </div>

  <div className="w-1/8 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Profile Id"}</label>
    <InputText className="w-full text-base" 
    id="username" value={profileId}
    onChange={(e) => setProfileId(e.target.value)}
    readOnly
    />
  </div>

  <button 
              onClick={() => setVisible2(true)} 
             className="cursor-pointer mt-5 flex items-center m-0 text-violet-700 hover:text-violet-400 "
             >
              <svg 
               className="w-6 h-6 text-gray-800 dark:text-white" 
               aria-hidden="true" 
               xmlns="http://www.w3.org/2000/svg" 
               fill="none" 
              viewBox="0 0 20 20"
                >
              <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
            </svg>
           </button>

           <Divider layout="vertical" />


           <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Member"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={guestGuestType} 
    onChange={(e) => guestGuestType(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Member Type"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
       style={{ width: '95%' }}
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={guestGuestType}
         options={guestMemberIems}
         onChange={(e) => setGuestType(e.value)}
         placeholder={"Member Type"}
         />
       </div>
   


  <div className="mr-2 w-1/8">
    <label htmlFor="firmType" className="block font-medium text-gray-700"> 
      {"Aktif"}
    </label>
    <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
  </div> 

  </div>

  

  <div className="flex gap-4">


       <div>
    <label htmlFor="roomClassDropdown" className="col-span-3 w-fit block font-medium text-gray-700">
      {"Title"}
    </label>
    <Dropdown
      className="h-11  w-5 rounded-md" // Bu satır eklenmiştir
      style={{ width: '95%' }}
      dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
      <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
    </svg>}
      value={guestTitle}
      options={guesttitletems}
      onChange={(e) => setGuestTitle(e.value)}
      placeholder={"Mr Etc."}
    />
  </div>
          <div className="w-2/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Name"}</label>
    <InputText className="w-full text-base" 
    id="username" value={guestName}
    onChange={(e) => setGuestName(e.target.value)}
    
    />
  </div>

  <div className="w-2/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">{"Last Name"}</label>
    <InputText className="w-full text-base" 
    id="username" value={guestLastN}
    onChange={(e) => setGuestLastN(e.target.value)}
  
    />
  </div>


  <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Age"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={guestAge} 
    onChange={(e) => setGuestAge(e.target.value)} autoComplete="off"/>
    
  </div>

  

       <div className="w-1/5 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">{"Country"}</label>
    <InputText className="w-full text-base" 
    id="firmname" value={guestCountry} 
    onChange={(e) => setGuestCountry(e.target.value)} autoComplete="off"/>
    
  </div>

  <div>
        <label htmlFor="roomClassDropdown" className="font-medium text-gray-700">
        {"Type Name"}
       </label>
       <Dropdown
       className="h-11  w-56 rounded-md" // Bu satır eklenmiştir
       style={{ width: '95%' }}
        dropdownIcon={  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
         <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
         </svg>}
         value={resRoomType}
         options={rulesTypeItems}
         onChange={(e) => setResRoomType(e.value)}
         placeholder={select_rule_type_hint}
         />
       </div>
   


 

  </div>

      <div className="flex mt-5 mb-0 gap-4 ">
      <div className="w-2/4">
     
  </div>

  
  <div className="w-2/4">
    <Button
      label={"New Profile"}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={onClick3}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={update}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-900 hover:bg-violet-900 text-white font-semibold rounded-md"
      onClick={handleUpdate}
    />
  </div>
  <div className="w-2/4">
    <Button
      label={"New Room"}
      aria-label="Update"
      className="w-full p-button-sm p-button-outlined bg-purple-800 hover:bg-indigo-500 text-white font-semibold rounded-md"
      onClick={handleUpdateIdSeq}
    />
  </div>
</div>

<div>
<Dialog visible={displayBasic}  style={{ width: '85vw' }}maximizable header={"Custommer Profile"} onHide={onHide}>
  <p>
   {<CustommerProfileCorp/>}
  </p>
</Dialog>
</div>
</p>
   </Fieldset>
       </div>
 
       </div>          
  
  </div>



  <TabView className="flex m-0 p-0 list-none flex-nowrap" activeIndex={activeTabS} onTabChange={(e) => handleTabChangeS(e.index)}>
           <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 0 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Custommer Profile"}
            </span>
          }
          className="ml-5 flex"
        >
    
  

 <p> <DataTable
         value={firmData2 }
         scrollable 
         scrollHeight="250px" loading={loading}
         stickyHeader
         stickyTopAt=".layout-topbar"
        

        >
           <Column field="cust_profile_id"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{" Id"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="title"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{" Title"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="first_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"First Name"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="middle_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{" Middle Name"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="last_name"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{" Last Name"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column
           field="birth_date"
           header={<span className="font-bold text-sm text-gray-900">{"Birth Date"}</span>}
           body={(rowData) => {
           const dateTimeString = rowData.date;
           const dateObj = new Date(dateTimeString);
           const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
           const formattedDate = `${dateObj.toLocaleDateString('en-GB', options)} `;
           

          return (
           <div className="text-sm">
           {formattedDate}
           </div>
            );
           }}
          style={{ textAlign: 'left', width: '10rem' }}
           />

         <Column field="nationality"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Nationality"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="member_class"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Member"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>

          <Column field="member_club"
           className="text-xs text-right" 
           header={<span className="font-bold text-gray-900">{"Club"}</span>}
           style={{ textAlign: 'left', width: '5rem' }}
          >
          </Column>
        

          <Column
            field="hidden"
            body={getStatusLabel}
            header={<span className="font-bold text-gray-900">{'Hidden'}</span>}
            style={{ textAlign: 'center', width: '5rem' }}
            className="font-bold text-sm" 
          />


          <Column
          header={<span className="font-bold text-sm text-gray-900">{detail}</span>}
          body={(rowData) => (
            <button
              onClick={() => {               
             //   setVarCode8(rowData.dpr_sub_code);  
                setVarCode(rowData.cust_profile_id);                          
                onClick();
              
                
              }}
              className="p-1 rounded-full dark:text-gray-600 hover:dark:bg-gray-700 focus:dark:bg-gray-700"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-current">
                <path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" />
              </svg>
            </button>
          )}
          style={{ textAlign: 'center', width: '6rem' }}
        ></Column>
    
        </DataTable></p>    

        </TabPanel>
              <TabPanel   header={
            <span
              className={`font-bold hover:border-b-2 cursor-pointer  hover:border-purple-500 border-b-2 p-3 focus:outline-none focus:outline-offset-0 focus:shadow-[inset_0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[inset_0_0_0_0.2rem_rgba(147,197,253,0.5)] rounded-t-lg select-none flex items-center relative no-underline overflow-hidden${
                activeTabS === 1 ? ' bg-white border-violet-800 text-violet-800 dark:bg-gray-900 dark:border-violet-300 dark:text-violet-300' : 'text-sienna-700'
                
              }`}
            >
              {"Cont"}
            </span>
          }
          className="ml-5 flex"
        >


      
       
       
       
      
       



         
    

              </TabPanel>
            
          </TabView>   
     
    

        

              </TabPanel>
           

           
            
          </TabView>   
     
    </div>




    
    
    
 
 
);
};

export default HtlResRoomGuestEdit;

/*

  
<DataTable
value={rows}
scrollable 
scrollHeight="250px"
loading={loading}
stickyHeader
stickyTopAt=".layout-topbar"
>
<Column
  field="date"
  header={<span className="font-bold text-sm text-gray-900">{"Date"}</span>}
  style={{ textAlign: 'left', width: '10rem' }}
/>
<Column
  field="period"
  header={<span className="font-bold text-sm text-gray-900">{"Period"}</span>}
  style={{ textAlign: 'left', width: '10rem' }}
/>

<Column
  field="per_price"
  header={<span className="font-bold text-sm text-gray-900">{"Period"}</span>}
  style={{ textAlign: 'left', width: '10rem' }}
/>
<Column
  field="currency"
  header={<span className="font-bold text-sm text-gray-900">{"currency"}</span>}
  style={{ textAlign: 'left', width: '10rem' }}
/>

</DataTable>
*/
